// import React, { useEffect, useMemo, useState } from "react";
// import {
//   Box,
//   Typography,
//   CircularProgress,
//   Table,
//   TableHead,
//   TableBody,
//   TableRow,
//   TableCell,
//   Paper,
//   Stack,
//   IconButton,
//   Tooltip,
// } from "@mui/material";
// import {
//   TaskAltRounded,
//   TodayRounded,
//   TimerOutlined,
//   RefreshOutlined,
//   FirstPageRounded,
//   LastPageRounded,
//   ChevronLeftRounded,
//   ChevronRightRounded,
// } from "@mui/icons-material";
// import { keyframes } from "@mui/system";
// import { supporterService } from "../services/supporterService";
// import { parseServerDate } from "../../../utils/dateUtils";
// import {
//   STORAGE_KEYS,
//   MESSAGES,
//   textPrimary,
//   textSecondary,
// } from "../../../constants/consts";
// import { useNavigate } from "react-router-dom";
// const fadeInUp = keyframes`
//   from { opacity: 0; transform: translateY(14px); }
//   to   { opacity: 1; transform: translateY(0); }
// `;

// const PAGE_SIZE = 13;

// export default function SupporterCompleted({ user }) {
//   const navigate = useNavigate();
//   const [rows, setRows] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [refreshing, setRefreshing] = useState(false);
//   const [page, setPage] = useState(0);

//   const username =
//     user?.username ||
//     localStorage.getItem(STORAGE_KEYS.USERNAME) ||
//     sessionStorage.getItem(STORAGE_KEYS.USERNAME) ||
//     "";

//   /* ─────────────── Veri yükleme ─────────────── */
//   const loadData = async (silent = false) => {
//     if (silent) setRefreshing(true);
//     else setLoading(true);

//     try {
//       const data = await supporterService.getSupportsFilter({
//         personel: username,
//         durum: "Tamamlandı",
//       });
//       const userIds = [...new Set(data.map((d) => String(d.user_id)))];
//       const cache = {};
//       for (let i = 0; i < userIds.length; i += 50) {
//         const chunk = userIds.slice(i, i + 50);
//         const res = await Promise.all(
//           chunk.map((id) => supporterService.getUserById(id)),
//         );
//         chunk.forEach((id, j) => (cache[id] = res[j]));
//       }
//       setRows(
//         data.map((d) => {
//           // const start = d.start_at ? new Date(d.start_at) : null;
//           // const end = d.end_at ? new Date(d.end_at) : null;

//           const start = d.start_at ? parseServerDate(d.start_at) : null;
//           const end = d.end_at ? parseServerDate(d.end_at) : null;
//           return {
//             id: d.id,
//             title: d.title,
//             sunucu: cache[String(d.user_id)]?.sunucu_kodu ?? "",
//             contract:
//               d.contract === "no"
//                 ? "Yok"
//                 : d.contract === "yes"
//                   ? "Var"
//                   : d.contract === "New"
//                     ? "Yeni"
//                     : "",
//             username: cache[String(d.user_id)]?.username ?? "",
//             supporter: d.supporter || "Atanmadı",
//             duration: start && end ? formatDuration(start, end) : null,
//             durationMinutes: start && end ? (end - start) / 60000 : null,
//             createdAt: d.created_at ? formatDate(d.created_at) : "-",
//             endAt: end,
//           };
//         }),
//       );
//       setPage(0);
//     } catch (e) {
//       console.error(e);
//     } finally {
//       if (silent) setRefreshing(false);
//       else setLoading(false);
//     }
//   };

//   useEffect(() => {
//     loadData();
//     // eslint-disable-next-line
//   }, [username]);

//   /* ─────────────── İstatistikler ─────────────── */
//   const stats = useMemo(() => {
//     const now = new Date();
//     const today = rows.filter(
//       (r) =>
//         r.endAt &&
//         r.endAt.getFullYear() === now.getFullYear() &&
//         r.endAt.getMonth() === now.getMonth() &&
//         r.endAt.getDate() === now.getDate(),
//     ).length;

//     // Ortalama süre (dakika cinsinden geçerli kayıtlar üzerinden)
//     const valid = rows.filter((r) => r.durationMinutes != null);
//     const totalMin = valid.reduce((sum, r) => sum + r.durationMinutes, 0);
//     const avgMin = valid.length ? totalMin / valid.length : 0;
//     const avgText =
//       valid.length === 0
//         ? "—"
//         : avgMin >= 60
//           ? `${(avgMin / 60).toFixed(1)} sa`
//           : `${Math.round(avgMin)} dk`;

//     return { total: rows.length, today, avgText };
//   }, [rows]);

//   /* ─────────────── Sayfalama ─────────────── */
//   const totalPages = Math.max(1, Math.ceil(rows.length / PAGE_SIZE));
//   const safePage = Math.min(page, totalPages - 1);

//   const pageRows = useMemo(() => {
//     const start = safePage * PAGE_SIZE;
//     return rows.slice(start, start + PAGE_SIZE);
//   }, [rows, safePage]);

//   const startIdx = safePage * PAGE_SIZE + 1;
//   const endIdx = Math.min((safePage + 1) * PAGE_SIZE, rows.length);

//   return (
//     <Box
//       sx={{
//         height: "100%", // ← flex:1 ve minHeight:0 SİL
//         display: "flex",
//         flexDirection: "column",
//         gap: 1.5,
//         overflow: "hidden",
//         boxSizing: "border-box",
//       }}
//     >
//       {/* ─────────── BAŞLIK ─────────── */}
//       <Box
//         sx={{
//           display: "flex",
//           alignItems: "center",
//           gap: 1,
//           flexShrink: 0,
//           animation: `${fadeInUp} 0.4s ease-out both`,
//         }}
//       >
//         <Box
//           sx={{
//             width: 34,
//             height: 34,
//             borderRadius: 2,
//             display: "flex",
//             alignItems: "center",
//             justifyContent: "center",
//             backgroundColor: "rgba(255,255,255,0.14)",
//             backdropFilter: "blur(8px)",
//             border: "1px solid rgba(255,255,255,0.20)",
//           }}
//         >
//           <TaskAltRounded sx={{ color: "#fff", fontSize: 20 }} />
//         </Box>
//         <Box sx={{ minWidth: 0 }}>
//           <Typography
//             variant="h6"
//             fontWeight={800}
//             color="#fff"
//             sx={{ fontSize: 16, lineHeight: 1.2 }}
//           >
//             {MESSAGES.SUPPORTER_COMPLETED_HEADER}
//           </Typography>
//           <Typography
//             sx={{
//               color: "rgba(255,255,255,0.7)",
//               fontSize: 11.5,
//               fontWeight: 600,
//             }}
//           >
//             Tamamlanan destek talepleri listesi
//           </Typography>
//         </Box>

//         <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
//           <Box
//             sx={{
//               px: 1.25,
//               py: 0.4,
//               borderRadius: 5,
//               backgroundColor: "rgba(255,255,255,0.14)",
//               color: "#fff",
//               fontWeight: 700,
//               fontSize: 12,
//               backdropFilter: "blur(8px)",
//               border: "1px solid rgba(255,255,255,0.18)",
//             }}
//           >
//             {rows.length} kayıt
//           </Box>
//           <Tooltip title="Yenile">
//             <span>
//               <IconButton
//                 size="small"
//                 onClick={() => loadData(true)}
//                 disabled={loading || refreshing}
//                 sx={{
//                   color: "#fff",
//                   backgroundColor: "rgba(255,255,255,0.12)",
//                   backdropFilter: "blur(8px)",
//                   border: "1px solid rgba(255,255,255,0.18)",
//                   "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
//                   "&.Mui-disabled": { color: "rgba(255,255,255,0.4)" },
//                 }}
//               >
//                 <RefreshOutlined
//                   sx={{
//                     fontSize: 18,
//                     animation:
//                       loading || refreshing
//                         ? "spin 1.2s linear infinite"
//                         : "none",
//                     "@keyframes spin": {
//                       to: { transform: "rotate(360deg)" },
//                     },
//                   }}
//                 />
//               </IconButton>
//             </span>
//           </Tooltip>
//         </Box>
//       </Box>

//       {/* ─────────── İSTATİSTİK KARTLARI ─────────── */}
//       <Stack
//         direction={{ xs: "column", sm: "row" }}
//         spacing={1.5}
//         sx={{ flexShrink: 0 }}
//       >
//         <StatCard
//           icon={TaskAltRounded}
//           label={MESSAGES.SUPPORTER_STAT_TOTAL}
//           value={stats.total}
//           color="#0EA5E9"
//           delay={0.05}
//         />
//         <StatCard
//           icon={TodayRounded}
//           label={MESSAGES.SUPPORTER_STAT_TODAY}
//           value={stats.today}
//           color="#22C55E"
//           delay={0.12}
//         />
//         <StatCard
//           icon={TimerOutlined}
//           label={MESSAGES.SUPPORTER_STAT_AVG}
//           value={stats.avgText}
//           color="#F59E0B"
//           delay={0.19}
//         />
//       </Stack>

//       {loading ? (
//         <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
//           <CircularProgress sx={{ color: "#fff" }} />
//         </Box>
//       ) : (
//         <>
//           {/* ─────────── TABLO ─────────── */}
//           <Paper
//             elevation={0}
//             sx={{
//               flex: 1,
//               minHeight: 0,
//               overflow: "hidden",
//               borderRadius: 2.5,
//               display: "flex",
//               flexDirection: "column",
//               backgroundColor: "rgba(255,255,255,0.98)",
//               boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
//               border: "1px solid rgba(255,255,255,0.30)",
//               animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.25s backwards`,
//             }}
//           >
//             <Box
//               sx={{
//                 flex: 1,
//                 minHeight: 0,
//                 overflowY: "auto",
//                 overflowX: "hidden",
//                 "&::-webkit-scrollbar": { width: 6 },
//                 "&::-webkit-scrollbar-thumb": {
//                   backgroundColor: "rgba(15,50,65,0.20)",
//                   borderRadius: 3,
//                 },
//                 "&::-webkit-scrollbar-thumb:hover": {
//                   backgroundColor: "rgba(15,50,65,0.35)",
//                 },
//                 "&::-webkit-scrollbar-track": { background: "transparent" },
//               }}
//             >
//               <Table stickyHeader size="small">
//                 <TableHead>
//                   <TableRow
//                     sx={{
//                       "& th": {
//                         background:
//                           "linear-gradient(180deg, #F1F5F9 0%, #E2E8F0 100%)",
//                         color: "#334155",
//                         fontWeight: 800,
//                         fontSize: 10.5,
//                         textTransform: "uppercase",
//                         letterSpacing: "0.05em",
//                         py: 1,
//                         px: 1.5,
//                         borderBottom: "1px solid #CBD5E1",
//                         whiteSpace: "nowrap",
//                       },
//                       "& th:first-of-type": {
//                         borderTopLeftRadius: 10,
//                         pl: 2,
//                       },
//                       "& th:last-of-type": {
//                         borderTopRightRadius: 10,
//                         pr: 2,
//                       },
//                     }}
//                   >
//                     <TableCell>Konu</TableCell>
//                     <TableCell>Sunucu</TableCell>
//                     <TableCell>Sözleşme</TableCell>
//                     <TableCell>Hizmet Alan</TableCell>
//                     <TableCell>Hizmet Veren</TableCell>
//                     <TableCell>Süre</TableCell>
//                     <TableCell>Tarih</TableCell>
//                   </TableRow>
//                 </TableHead>
//                 <TableBody>
//                   {pageRows.length === 0 ? (
//                     <TableRow>
//                       <TableCell
//                         colSpan={7}
//                         sx={{
//                           textAlign: "center",
//                           py: 6,
//                           color: textSecondary,
//                           fontSize: 13,
//                         }}
//                       >
//                         Henüz tamamlanmış iş kaydı bulunmuyor
//                       </TableCell>
//                     </TableRow>
//                   ) : (
//                     pageRows.map((r, i) => (
//                       // <TableRow
//                       //   key={r.id}
//                       //   sx={{
//                       //     backgroundColor: i % 2 ? "#F8FAFC" : "#fff",
//                       //     "&:hover": {
//                       //       backgroundColor: "rgba(14,165,233,0.06)",
//                       //     },
//                       //     transition: "background-color 0.2s ease",
//                       //     animation: `${fadeInUp} 0.35s ease-out ${
//                       //       i * 0.03
//                       //     }s backwards`,
//                       //     "& td": {
//                       //       py: 0.75,
//                       //       px: 1.5,
//                       //       fontSize: 12.5,
//                       //       color: "#334155",
//                       //       borderBottom: "1px solid #F1F5F9",
//                       //     },
//                       //     "& td:first-of-type": { pl: 2 },
//                       //     "& td:last-of-type": { pr: 2 },
//                       //   }}
//                       // >
//                       <TableRow
//                         key={r.id}
//                         onClick={() =>
//                           navigate(`/support/${r.id}/messages`, {
//                             state: {
//                               title: r.title,
//                               status: "Tamamlandı",
//                               sunucuKodu: r.sunucu,
//                             },
//                           })
//                         }
//                         sx={{
//                           cursor: "pointer",
//                           backgroundColor: i % 2 ? "#F8FAFC" : "#fff",
//                           "&:hover": {
//                             backgroundColor: "rgba(14,165,233,0.10)",
//                           },
//                           transition: "background-color 0.2s ease",
//                           animation: `${fadeInUp} 0.35s ease-out ${
//                             i * 0.03
//                           }s backwards`,
//                           "& td": {
//                             py: 0.75,
//                             px: 1.5,
//                             fontSize: 12.5,
//                             color: "#334155",
//                             borderBottom: "1px solid #F1F5F9",
//                           },
//                           "& td:first-of-type": { pl: 2 },
//                           "& td:last-of-type": { pr: 2 },
//                         }}
//                       >
//                         <TableCell
//                           sx={{
//                             fontWeight: 700,
//                             color: textPrimary,
//                             maxWidth: 220,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                           title={r.title}
//                         >
//                           {r.title}
//                         </TableCell>
//                         <TableCell>{r.sunucu}</TableCell>
//                         <TableCell>
//                           <ContractChip contract={r.contract} />
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             maxWidth: 160,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {r.username}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             maxWidth: 160,
//                             overflow: "hidden",
//                             textOverflow: "ellipsis",
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {r.supporter}
//                         </TableCell>
//                         <TableCell>
//                           {r.duration ? (
//                             <Box
//                               component="span"
//                               sx={{
//                                 display: "inline-block",
//                                 px: 0.9,
//                                 py: 0.2,
//                                 borderRadius: 5,
//                                 backgroundColor: "#DCFCE7",
//                                 color: "#15803D",
//                                 fontWeight: 700,
//                                 fontSize: 11,
//                                 verticalAlign: "middle",
//                               }}
//                             >
//                               {r.duration}
//                             </Box>
//                           ) : (
//                             <Box component="span" sx={{ color: "#94A3B8" }}>
//                               —
//                             </Box>
//                           )}
//                         </TableCell>
//                         <TableCell
//                           sx={{
//                             color: textSecondary,
//                             fontSize: 12,
//                             whiteSpace: "nowrap",
//                           }}
//                         >
//                           {r.createdAt}
//                         </TableCell>
//                       </TableRow>
//                     ))
//                   )}
//                 </TableBody>
//               </Table>
//             </Box>
//           </Paper>

//           {/* ─────────── SAYFALAMA ─────────── */}
//           {rows.length > 0 && (
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 justifyContent: "space-between",
//                 gap: 1,
//                 flexShrink: 0,
//                 px: 0.5,
//                 animation: `${fadeInUp} 0.4s ease-out 0.35s backwards`,
//               }}
//             >
//               <Typography
//                 sx={{
//                   color: "rgba(255,255,255,0.75)",
//                   fontSize: 11.5,
//                   fontWeight: 600,
//                 }}
//               >
//                 {startIdx}–{endIdx} / {rows.length} kayıt
//               </Typography>

//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//                 <PagerBtn
//                   icon={FirstPageRounded}
//                   disabled={safePage === 0}
//                   onClick={() => setPage(0)}
//                 />
//                 <PagerBtn
//                   icon={ChevronLeftRounded}
//                   disabled={safePage === 0}
//                   onClick={() => setPage((p) => Math.max(0, p - 1))}
//                 />

//                 <Box
//                   sx={{
//                     mx: 1,
//                     px: 1.5,
//                     py: 0.5,
//                     borderRadius: 1.5,
//                     backgroundColor: "rgba(255,255,255,0.12)",
//                     backdropFilter: "blur(8px)",
//                     border: "1px solid rgba(255,255,255,0.18)",
//                     color: "#fff",
//                     fontSize: 12,
//                     fontWeight: 700,
//                     minWidth: 62,
//                     textAlign: "center",
//                   }}
//                 >
//                   {safePage + 1} / {totalPages}
//                 </Box>

//                 <PagerBtn
//                   icon={ChevronRightRounded}
//                   disabled={safePage >= totalPages - 1}
//                   onClick={() =>
//                     setPage((p) => Math.min(totalPages - 1, p + 1))
//                   }
//                 />
//                 <PagerBtn
//                   icon={LastPageRounded}
//                   disabled={safePage >= totalPages - 1}
//                   onClick={() => setPage(totalPages - 1)}
//                 />
//               </Box>
//             </Box>
//           )}
//         </>
//       )}
//     </Box>
//   );
// }

// /* ─────────────── Stat kartı ─────────────── */
// function StatCard({ icon: Icon, label, value, color, delay = 0 }) {
//   return (
//     <Box
//       sx={{
//         flex: 1,
//         display: "flex",
//         alignItems: "center",
//         gap: 1.25,
//         p: 1.5,
//         borderRadius: 2.5,
//         backgroundColor: "rgba(255,255,255,0.10)",
//         border: "1px solid rgba(255,255,255,0.15)",
//         backdropFilter: "blur(8px)",
//         animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s backwards`,
//         transition: "transform 0.25s ease, background 0.25s ease",
//         "&:hover": {
//           transform: "translateY(-2px)",
//           backgroundColor: "rgba(255,255,255,0.16)",
//         },
//       }}
//     >
//       <Box
//         sx={{
//           width: 40,
//           height: 40,
//           borderRadius: 2,
//           backgroundColor: `${color}33`,
//           color,
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexShrink: 0,
//         }}
//       >
//         <Icon sx={{ fontSize: 20 }} />
//       </Box>
//       <Box sx={{ minWidth: 0 }}>
//         <Typography
//           sx={{ color: "#fff", fontWeight: 800, fontSize: 18, lineHeight: 1.1 }}
//         >
//           {value}
//         </Typography>
//         <Typography
//           sx={{
//             color: "rgba(255,255,255,0.65)",
//             fontSize: 11.5,
//             fontWeight: 600,
//           }}
//           noWrap
//         >
//           {label}
//         </Typography>
//       </Box>
//     </Box>
//   );
// }

// /* ─────────────── Sayfalama butonu ─────────────── */
// function PagerBtn({ icon: Icon, disabled, onClick }) {
//   return (
//     <IconButton
//       size="small"
//       disabled={disabled}
//       onClick={onClick}
//       sx={{
//         width: 30,
//         height: 30,
//         color: "#fff",
//         backgroundColor: "rgba(255,255,255,0.10)",
//         border: "1px solid rgba(255,255,255,0.18)",
//         transition:
//           "transform 0.18s ease, background-color 0.18s ease, color 0.18s ease",
//         "&:hover": {
//           backgroundColor: "rgba(255,255,255,0.22)",
//           transform: "scale(1.06)",
//         },
//         "&:active": { transform: "scale(0.92)" },
//         "&.Mui-disabled": {
//           color: "rgba(255,255,255,0.25)",
//           backgroundColor: "rgba(255,255,255,0.04)",
//           borderColor: "rgba(255,255,255,0.08)",
//         },
//       }}
//     >
//       <Icon sx={{ fontSize: 18 }} />
//     </IconButton>
//   );
// }

// /* ─────────────── Sözleşme rozeti ─────────────── */
// function ContractChip({ contract }) {
//   const map = {
//     Var: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC" },
//     Yok: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5" },
//     Yeni: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD" },
//   };
//   const theme = map[contract] || {
//     fg: "#475569",
//     bg: "#F1F5F9",
//     border: "#CBD5E1",
//   };
//   if (!contract)
//     return (
//       <Box component="span" sx={{ color: "#94A3B8" }}>
//         —
//       </Box>
//     );
//   return (
//     <Box
//       component="span"
//       sx={{
//         display: "inline-block",
//         px: 0.9,
//         py: 0.2,
//         borderRadius: 1,
//         backgroundColor: theme.bg,
//         color: theme.fg,
//         border: `1px solid ${theme.border}`,
//         fontWeight: 700,
//         fontSize: 10.5,
//         verticalAlign: "middle",
//       }}
//     >
//       {contract}
//     </Box>
//   );
// }

// /* ─────────────── Tarih yardımcıları ─────────────── */
// // function formatDate(input) {
// //   if (!input) return "";
// //   const d = new Date(input);
// //   if (isNaN(d.getTime())) return input;
// //   const p = (n) => String(n).padStart(2, "0");
// //   return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
// //     d.getHours(),
// //   )}:${p(d.getMinutes())}`;
// // }
// function formatDate(input) {
//   if (!input) return "";
//   const d = parseServerDate(input);
//   if (isNaN(d.getTime())) return input;
//   const p = (n) => String(n).padStart(2, "0");
//   return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
//     d.getHours(),
//   )}:${p(d.getMinutes())}`;
// }
// function formatDuration(start, end) {
//   const diff = end - start;
//   const h = Math.floor(diff / 3600000);
//   const m = Math.floor((diff % 3600000) / 60000);
//   if (h > 0) return `${h} sa ${m} dk`;
//   return `${m} dk`;
// }
import React, { useEffect, useMemo, useState } from "react";
import {
  Box,
  Typography,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Stack,
  IconButton,
  Tooltip,
  Autocomplete,
  TextField,
  Chip,
} from "@mui/material";
import {
  TaskAltRounded,
  TodayRounded,
  TimerOutlined,
  RefreshOutlined,
  FirstPageRounded,
  LastPageRounded,
  ChevronLeftRounded,
  ChevronRightRounded,
  StorageRounded,
  ClearRounded,
} from "@mui/icons-material";
import { keyframes } from "@mui/system";
import { supporterService } from "../services/supporterService";
import { parseServerDate } from "../../../utils/dateUtils";
import {
  STORAGE_KEYS,
  MESSAGES,
  textPrimary,
  textSecondary,
} from "../../../constants/consts";
import { useNavigate } from "react-router-dom";

const fadeInUp = keyframes`
  from { opacity: 0; transform: translateY(14px); }
  to   { opacity: 1; transform: translateY(0); }
`;

const PAGE_SIZE = 12;

export default function SupporterCompleted({ user }) {
  const navigate = useNavigate();
  const [rows, setRows] = useState([]);
  const [loading, setLoading] = useState(true);
  const [refreshing, setRefreshing] = useState(false);
  const [page, setPage] = useState(0);
  const [selectedSunucu, setSelectedSunucu] = useState(null); // 🔵 sunucu filtresi

  const username =
    user?.username ||
    localStorage.getItem(STORAGE_KEYS.USERNAME) ||
    sessionStorage.getItem(STORAGE_KEYS.USERNAME) ||
    "";

  /* ─────────────── Veri yükleme ─────────────── */
  const loadData = async (silent = false) => {
    if (silent) setRefreshing(true);
    else setLoading(true);

    try {
      const data = await supporterService.getSupportsFilter({
        personel: username,
        durum: "Tamamlandı",
      });
      const userIds = [...new Set(data.map((d) => String(d.user_id)))];
      const cache = {};
      for (let i = 0; i < userIds.length; i += 50) {
        const chunk = userIds.slice(i, i + 50);
        const res = await Promise.all(
          chunk.map((id) => supporterService.getUserById(id)),
        );
        chunk.forEach((id, j) => (cache[id] = res[j]));
      }
      setRows(
        data.map((d) => {
          const start = d.start_at ? parseServerDate(d.start_at) : null;
          const end = d.end_at ? parseServerDate(d.end_at) : null;
          return {
            id: d.id,
            title: d.title,
            sunucu: cache[String(d.user_id)]?.sunucu_kodu ?? "",
            contract:
              d.contract === "no"
                ? "Yok"
                : d.contract === "yes"
                  ? "Var"
                  : d.contract === "New"
                    ? "Yeni"
                    : "",
            username: cache[String(d.user_id)]?.username ?? "",
            supporter: d.supporter || "Atanmadı",
            duration: start && end ? formatDuration(start, end) : null,
            durationMinutes: start && end ? (end - start) / 60000 : null,
            createdAt: d.created_at ? formatDate(d.created_at) : "-",
            endAt: end,
          };
        }),
      );
      setPage(0);
    } catch (e) {
      console.error(e);
    } finally {
      if (silent) setRefreshing(false);
      else setLoading(false);
    }
  };

  useEffect(() => {
    loadData();
    // eslint-disable-next-line
  }, [username]);

  /* ─────────────── 🔵 SUNUCU LİSTESİ (sadece dolu olanlar, tekil) ─────────────── */
  const sunucuOptions = useMemo(() => {
    const set = new Set();
    rows.forEach((r) => {
      const s = (r.sunucu || "").trim();
      if (s) set.add(s);
    });
    return Array.from(set).sort((a, b) =>
      a.localeCompare(b, "tr", { numeric: true }),
    );
  }, [rows]);

  /* ─────────────── 🔵 FİLTRELENMİŞ SATIRLAR ─────────────── */
  const filteredRows = useMemo(() => {
    if (!selectedSunucu) return rows;
    return rows.filter(
      (r) => (r.sunucu || "").trim() === selectedSunucu.trim(),
    );
  }, [rows, selectedSunucu]);

  /* ─────────────── İstatistikler (filtrelenmiş) ─────────────── */
  const stats = useMemo(() => {
    const now = new Date();
    const today = filteredRows.filter(
      (r) =>
        r.endAt &&
        r.endAt.getFullYear() === now.getFullYear() &&
        r.endAt.getMonth() === now.getMonth() &&
        r.endAt.getDate() === now.getDate(),
    ).length;

    const valid = filteredRows.filter((r) => r.durationMinutes != null);
    const totalMin = valid.reduce((sum, r) => sum + r.durationMinutes, 0);
    const avgMin = valid.length ? totalMin / valid.length : 0;
    const avgText =
      valid.length === 0
        ? "—"
        : avgMin >= 60
          ? `${(avgMin / 60).toFixed(1)} sa`
          : `${Math.round(avgMin)} dk`;

    return { total: filteredRows.length, today, avgText };
  }, [filteredRows]);

  /* ─────────────── Sayfalama (filtrelenmiş) ─────────────── */
  const totalPages = Math.max(1, Math.ceil(filteredRows.length / PAGE_SIZE));
  const safePage = Math.min(page, totalPages - 1);

  const pageRows = useMemo(() => {
    const start = safePage * PAGE_SIZE;
    return filteredRows.slice(start, start + PAGE_SIZE);
  }, [filteredRows, safePage]);

  const startIdx = filteredRows.length === 0 ? 0 : safePage * PAGE_SIZE + 1;
  const endIdx = Math.min((safePage + 1) * PAGE_SIZE, filteredRows.length);

  // Filtre değişince sayfayı sıfırla
  useEffect(() => {
    setPage(0);
  }, [selectedSunucu]);

  return (
    <Box
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        gap: 1.5,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      {/* ─────────── BAŞLIK ─────────── */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          flexShrink: 0,
          animation: `${fadeInUp} 0.4s ease-out both`,
        }}
      >
        <Box
          sx={{
            width: 34,
            height: 34,
            borderRadius: 2,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            backgroundColor: "rgba(255,255,255,0.14)",
            backdropFilter: "blur(8px)",
            border: "1px solid rgba(255,255,255,0.20)",
          }}
        >
          <TaskAltRounded sx={{ color: "#fff", fontSize: 20 }} />
        </Box>
        <Box sx={{ minWidth: 0 }}>
          <Typography
            variant="h6"
            fontWeight={800}
            color="#fff"
            sx={{ fontSize: 16, lineHeight: 1.2 }}
          >
            {MESSAGES.SUPPORTER_COMPLETED_HEADER}
          </Typography>
          <Typography
            sx={{
              color: "rgba(255,255,255,0.7)",
              fontSize: 11.5,
              fontWeight: 600,
            }}
          >
            Tamamlanan destek talepleri listesi
          </Typography>
        </Box>

        <Box sx={{ ml: "auto", display: "flex", alignItems: "center", gap: 1 }}>
          <Box
            sx={{
              px: 1.25,
              py: 0.4,
              borderRadius: 5,
              backgroundColor: "rgba(255,255,255,0.14)",
              color: "#fff",
              fontWeight: 700,
              fontSize: 12,
              backdropFilter: "blur(8px)",
              border: "1px solid rgba(255,255,255,0.18)",
            }}
          >
            {filteredRows.length} kayıt
          </Box>
          <Tooltip title="Yenile">
            <span>
              <IconButton
                size="small"
                onClick={() => loadData(true)}
                disabled={loading || refreshing}
                sx={{
                  color: "#fff",
                  backgroundColor: "rgba(255,255,255,0.12)",
                  backdropFilter: "blur(8px)",
                  border: "1px solid rgba(255,255,255,0.18)",
                  "&:hover": { backgroundColor: "rgba(255,255,255,0.22)" },
                  "&.Mui-disabled": { color: "rgba(255,255,255,0.4)" },
                }}
              >
                <RefreshOutlined
                  sx={{
                    fontSize: 18,
                    animation:
                      loading || refreshing
                        ? "spin 1.2s linear infinite"
                        : "none",
                    "@keyframes spin": {
                      to: { transform: "rotate(360deg)" },
                    },
                  }}
                />
              </IconButton>
            </span>
          </Tooltip>
        </Box>
      </Box>

      {/* ─────────── 🔵 SUNUCU FİLTRESİ ─────────── */}
      <Box
        sx={{
          flexShrink: 0,
          animation: `${fadeInUp} 0.45s ease-out 0.05s backwards`,
        }}
      >
        <Autocomplete
          size="small"
          options={sunucuOptions}
          value={selectedSunucu}
          onChange={(_, val) => setSelectedSunucu(val)}
          clearOnEscape
          noOptionsText="Sunucu bulunamadı"
          sx={{
            maxWidth: 340,
            "& .MuiOutlinedInput-root": {
              backgroundColor: "rgba(255,255,255,0.14)",
              backdropFilter: "blur(10px)",
              color: "#fff",
              borderRadius: 2,
              border: "1px solid rgba(255,255,255,0.20)",
              transition: "background-color 0.2s ease, border-color 0.2s ease",
              "& fieldset": { border: "none" },
              "&:hover": {
                backgroundColor: "rgba(255,255,255,0.20)",
              },
              "&.Mui-focused": {
                backgroundColor: "rgba(255,255,255,0.24)",
                border: "1px solid rgba(255,255,255,0.45)",
              },
            },
            "& .MuiInputBase-input": {
              color: "#fff",
              fontWeight: 600,
              fontSize: 13,
              "&::placeholder": {
                color: "rgba(255,255,255,0.65)",
                opacity: 1,
              },
            },
            "& .MuiAutocomplete-popupIndicator, & .MuiAutocomplete-clearIndicator":
              {
                color: "rgba(255,255,255,0.75)",
              },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              placeholder="Sunucu ile filtrele..."
              InputProps={{
                ...params.InputProps,
                startAdornment: (
                  <>
                    <StorageRounded
                      sx={{
                        fontSize: 18,
                        color: "rgba(255,255,255,0.85)",
                        mr: 0.5,
                      }}
                    />
                    {params.InputProps.startAdornment}
                  </>
                ),
              }}
            />
          )}
          renderOption={(props, option) => (
            <Box
              component="li"
              {...props}
              key={option}
              sx={{ fontSize: 13, fontWeight: 600 }}
            >
              <StorageRounded sx={{ fontSize: 16, mr: 1, color: "#64748B" }} />
              {option}
            </Box>
          )}
        />

        {/* Aktif filtre çipi */}
        {selectedSunucu && (
          <Box
            sx={{
              mt: 0.75,
              display: "flex",
              alignItems: "center",
              gap: 1,
              animation: `${fadeInUp} 0.3s ease-out both`,
            }}
          >
            <Typography
              sx={{
                color: "rgba(255,255,255,0.7)",
                fontSize: 11.5,
                fontWeight: 600,
              }}
            >
              Aktif filtre:
            </Typography>
            <Chip
              label={selectedSunucu}
              size="small"
              onDelete={() => setSelectedSunucu(null)}
              deleteIcon={<ClearRounded sx={{ fontSize: 14 }} />}
              sx={{
                backgroundColor: "rgba(255,255,255,0.20)",
                color: "#fff",
                fontWeight: 700,
                fontSize: 11.5,
                border: "1px solid rgba(255,255,255,0.30)",
                "& .MuiChip-deleteIcon": {
                  color: "rgba(255,255,255,0.75)",
                  "&:hover": { color: "#fff" },
                },
              }}
            />
          </Box>
        )}
      </Box>

      {/* ─────────── İSTATİSTİK KARTLARI ─────────── */}
      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={1.5}
        sx={{ flexShrink: 0 }}
      >
        <StatCard
          icon={TaskAltRounded}
          label={MESSAGES.SUPPORTER_STAT_TOTAL}
          value={stats.total}
          color="#0EA5E9"
          delay={0.05}
        />
        <StatCard
          icon={TodayRounded}
          label={MESSAGES.SUPPORTER_STAT_TODAY}
          value={stats.today}
          color="#22C55E"
          delay={0.12}
        />
        <StatCard
          icon={TimerOutlined}
          label={MESSAGES.SUPPORTER_STAT_AVG}
          value={stats.avgText}
          color="#F59E0B"
          delay={0.19}
        />
      </Stack>

      {loading ? (
        <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
          <CircularProgress sx={{ color: "#fff" }} />
        </Box>
      ) : (
        <>
          {/* ─────────── TABLO ─────────── */}
          <Paper
            elevation={0}
            sx={{
              flex: 1,
              minHeight: 0,
              overflow: "hidden",
              borderRadius: 2.5,
              display: "flex",
              flexDirection: "column",
              backgroundColor: "rgba(255,255,255,0.98)",
              boxShadow: "0 12px 32px rgba(0,0,0,0.20)",
              border: "1px solid rgba(255,255,255,0.30)",
              animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) 0.25s backwards`,
            }}
          >
            <Box
              sx={{
                flex: 1,
                minHeight: 0,
                overflowY: "auto",
                overflowX: "hidden",
                "&::-webkit-scrollbar": { width: 6 },
                "&::-webkit-scrollbar-thumb": {
                  backgroundColor: "rgba(15,50,65,0.20)",
                  borderRadius: 3,
                },
                "&::-webkit-scrollbar-thumb:hover": {
                  backgroundColor: "rgba(15,50,65,0.35)",
                },
                "&::-webkit-scrollbar-track": { background: "transparent" },
              }}
            >
              <Table stickyHeader size="small">
                <TableHead>
                  <TableRow
                    sx={{
                      "& th": {
                        background:
                          "linear-gradient(180deg, #F1F5F9 0%, #E2E8F0 100%)",
                        color: "#334155",
                        fontWeight: 800,
                        fontSize: 10.5,
                        textTransform: "uppercase",
                        letterSpacing: "0.05em",
                        py: 1,
                        px: 1.5,
                        borderBottom: "1px solid #CBD5E1",
                        whiteSpace: "nowrap",
                      },
                      "& th:first-of-type": {
                        borderTopLeftRadius: 10,
                        pl: 2,
                      },
                      "& th:last-of-type": {
                        borderTopRightRadius: 10,
                        pr: 2,
                      },
                    }}
                  >
                    <TableCell>Konu</TableCell>
                    <TableCell>Sunucu</TableCell>
                    <TableCell>Sözleşme</TableCell>
                    <TableCell>Hizmet Alan</TableCell>
                    <TableCell>Hizmet Veren</TableCell>
                    <TableCell>Süre</TableCell>
                    <TableCell>Tarih</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {pageRows.length === 0 ? (
                    <TableRow>
                      <TableCell
                        colSpan={7}
                        sx={{
                          textAlign: "center",
                          py: 6,
                          color: textSecondary,
                          fontSize: 13,
                        }}
                      >
                        {selectedSunucu
                          ? `"${selectedSunucu}" sunucusu için kayıt bulunamadı`
                          : "Henüz tamamlanmış iş kaydı bulunmuyor"}
                      </TableCell>
                    </TableRow>
                  ) : (
                    pageRows.map((r, i) => (
                      <TableRow
                        key={r.id}
                        onClick={() =>
                          navigate(`/support/${r.id}/messages`, {
                            state: {
                              title: r.title,
                              status: "Tamamlandı",
                              sunucuKodu: r.sunucu,
                            },
                          })
                        }
                        sx={{
                          cursor: "pointer",
                          backgroundColor: i % 2 ? "#F8FAFC" : "#fff",
                          "&:hover": {
                            backgroundColor: "rgba(14,165,233,0.10)",
                          },
                          transition: "background-color 0.2s ease",
                          animation: `${fadeInUp} 0.35s ease-out ${
                            i * 0.03
                          }s backwards`,
                          "& td": {
                            py: 0.75,
                            px: 1.5,
                            fontSize: 12.5,
                            color: "#334155",
                            borderBottom: "1px solid #F1F5F9",
                          },
                          "& td:first-of-type": { pl: 2 },
                          "& td:last-of-type": { pr: 2 },
                        }}
                      >
                        <TableCell
                          sx={{
                            fontWeight: 700,
                            color: textPrimary,
                            maxWidth: 220,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                          title={r.title}
                        >
                          {r.title}
                        </TableCell>
                        <TableCell>
                          {r.sunucu ? (
                            <Box
                              component="span"
                              onClick={(e) => {
                                e.stopPropagation();
                                setSelectedSunucu(r.sunucu);
                              }}
                              sx={{
                                cursor: "pointer",
                                color: "#0EA5E9",
                                fontWeight: 700,
                                "&:hover": { textDecoration: "underline" },
                              }}
                              title="Bu sunucuya göre filtrele"
                            >
                              {r.sunucu}
                            </Box>
                          ) : (
                            <Box component="span" sx={{ color: "#94A3B8" }}>
                              —
                            </Box>
                          )}
                        </TableCell>
                        <TableCell>
                          <ContractChip contract={r.contract} />
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: 160,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {r.username}
                        </TableCell>
                        <TableCell
                          sx={{
                            maxWidth: 160,
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }}
                        >
                          {r.supporter}
                        </TableCell>
                        <TableCell>
                          {r.duration ? (
                            <Box
                              component="span"
                              sx={{
                                display: "inline-block",
                                px: 0.9,
                                py: 0.2,
                                borderRadius: 5,
                                backgroundColor: "#DCFCE7",
                                color: "#15803D",
                                fontWeight: 700,
                                fontSize: 11,
                                verticalAlign: "middle",
                              }}
                            >
                              {r.duration}
                            </Box>
                          ) : (
                            <Box component="span" sx={{ color: "#94A3B8" }}>
                              —
                            </Box>
                          )}
                        </TableCell>
                        <TableCell
                          sx={{
                            color: textSecondary,
                            fontSize: 12,
                            whiteSpace: "nowrap",
                          }}
                        >
                          {r.createdAt}
                        </TableCell>
                      </TableRow>
                    ))
                  )}
                </TableBody>
              </Table>
            </Box>
          </Paper>

          {/* ─────────── SAYFALAMA ─────────── */}
          {filteredRows.length > 0 && (
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                gap: 1,
                flexShrink: 0,
                px: 0.5,
                animation: `${fadeInUp} 0.4s ease-out 0.35s backwards`,
              }}
            >
              <Typography
                sx={{
                  color: "rgba(255,255,255,0.75)",
                  fontSize: 11.5,
                  fontWeight: 600,
                }}
              >
                {startIdx}–{endIdx} / {filteredRows.length} kayıt
              </Typography>

              <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                <PagerBtn
                  icon={FirstPageRounded}
                  disabled={safePage === 0}
                  onClick={() => setPage(0)}
                />
                <PagerBtn
                  icon={ChevronLeftRounded}
                  disabled={safePage === 0}
                  onClick={() => setPage((p) => Math.max(0, p - 1))}
                />

                <Box
                  sx={{
                    mx: 1,
                    px: 1.5,
                    py: 0.5,
                    borderRadius: 1.5,
                    backgroundColor: "rgba(255,255,255,0.12)",
                    backdropFilter: "blur(8px)",
                    border: "1px solid rgba(255,255,255,0.18)",
                    color: "#fff",
                    fontSize: 12,
                    fontWeight: 700,
                    minWidth: 62,
                    textAlign: "center",
                  }}
                >
                  {safePage + 1} / {totalPages}
                </Box>

                <PagerBtn
                  icon={ChevronRightRounded}
                  disabled={safePage >= totalPages - 1}
                  onClick={() =>
                    setPage((p) => Math.min(totalPages - 1, p + 1))
                  }
                />
                <PagerBtn
                  icon={LastPageRounded}
                  disabled={safePage >= totalPages - 1}
                  onClick={() => setPage(totalPages - 1)}
                />
              </Box>
            </Box>
          )}
        </>
      )}
    </Box>
  );
}

/* ─────────────── Stat kartı ─────────────── */
function StatCard({ icon: Icon, label, value, color, delay = 0 }) {
  return (
    <Box
      sx={{
        flex: 1,
        display: "flex",
        alignItems: "center",
        gap: 1.25,
        p: 1.5,
        borderRadius: 2.5,
        backgroundColor: "rgba(255,255,255,0.10)",
        border: "1px solid rgba(255,255,255,0.15)",
        backdropFilter: "blur(8px)",
        animation: `${fadeInUp} 0.5s cubic-bezier(0.22, 1, 0.36, 1) ${delay}s backwards`,
        transition: "transform 0.25s ease, background 0.25s ease",
        "&:hover": {
          transform: "translateY(-2px)",
          backgroundColor: "rgba(255,255,255,0.16)",
        },
      }}
    >
      <Box
        sx={{
          width: 40,
          height: 40,
          borderRadius: 2,
          backgroundColor: `${color}33`,
          color,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
        }}
      >
        <Icon sx={{ fontSize: 20 }} />
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{ color: "#fff", fontWeight: 800, fontSize: 18, lineHeight: 1.1 }}
        >
          {value}
        </Typography>
        <Typography
          sx={{
            color: "rgba(255,255,255,0.65)",
            fontSize: 11.5,
            fontWeight: 600,
          }}
          noWrap
        >
          {label}
        </Typography>
      </Box>
    </Box>
  );
}

/* ─────────────── Sayfalama butonu ─────────────── */
function PagerBtn({ icon: Icon, disabled, onClick }) {
  return (
    <IconButton
      size="small"
      disabled={disabled}
      onClick={onClick}
      sx={{
        width: 30,
        height: 30,
        color: "#fff",
        backgroundColor: "rgba(255,255,255,0.10)",
        border: "1px solid rgba(255,255,255,0.18)",
        transition:
          "transform 0.18s ease, background-color 0.18s ease, color 0.18s ease",
        "&:hover": {
          backgroundColor: "rgba(255,255,255,0.22)",
          transform: "scale(1.06)",
        },
        "&:active": { transform: "scale(0.92)" },
        "&.Mui-disabled": {
          color: "rgba(255,255,255,0.25)",
          backgroundColor: "rgba(255,255,255,0.04)",
          borderColor: "rgba(255,255,255,0.08)",
        },
      }}
    >
      <Icon sx={{ fontSize: 18 }} />
    </IconButton>
  );
}

/* ─────────────── Sözleşme rozeti ─────────────── */
function ContractChip({ contract }) {
  const map = {
    Var: { fg: "#15803D", bg: "#DCFCE7", border: "#86EFAC" },
    Yok: { fg: "#B91C1C", bg: "#FEE2E2", border: "#FCA5A5" },
    Yeni: { fg: "#1D4ED8", bg: "#DBEAFE", border: "#93C5FD" },
  };
  const theme = map[contract] || {
    fg: "#475569",
    bg: "#F1F5F9",
    border: "#CBD5E1",
  };
  if (!contract)
    return (
      <Box component="span" sx={{ color: "#94A3B8" }}>
        —
      </Box>
    );
  return (
    <Box
      component="span"
      sx={{
        display: "inline-block",
        px: 0.9,
        py: 0.2,
        borderRadius: 1,
        backgroundColor: theme.bg,
        color: theme.fg,
        border: `1px solid ${theme.border}`,
        fontWeight: 700,
        fontSize: 10.5,
        verticalAlign: "middle",
      }}
    >
      {contract}
    </Box>
  );
}

/* ─────────────── Tarih yardımcıları ─────────────── */
function formatDate(input) {
  if (!input) return "";
  const d = parseServerDate(input);
  if (!d || isNaN(d.getTime())) return input;
  const p = (n) => String(n).padStart(2, "0");
  return `${p(d.getDate())}/${p(d.getMonth() + 1)}/${d.getFullYear()} ${p(
    d.getHours(),
  )}:${p(d.getMinutes())}`;
}

function formatDuration(start, end) {
  const diff = end - start;
  const h = Math.floor(diff / 3600000);
  const m = Math.floor((diff % 3600000) / 60000);
  if (h > 0) return `${h} sa ${m} dk`;
  return `${m} dk`;
}
